import React from 'react'
import PropTypes from 'prop-types'
import InputLabel from '../../../typography/Input/InputLabel'
import styled from 'styled-components'
import colors from '../../../../configuration/colors'
import DefaultSelectComponent from '../../../mini/SelectComponents/DefaultSelectComponent'

const SelectorContainer = styled.div`
  position: relative;
`
const AsteriskSymbol = styled.span`
  color: ${colors.crimson};
  padding-left: 3px;
`

export const SelectorComponent = ({
  placeholder,
  handleSelectedValueChange,
  selectedValue,
  options,
  shouldDisplayAsterisk
}) => {
  return (
    <SelectorContainer>
      <InputLabel>
        {placeholder}
        {shouldDisplayAsterisk && <AsteriskSymbol>*</AsteriskSymbol>}
      </InputLabel>
      <DefaultSelectComponent
        placeholder={placeholder}
        handleSelectedValueChange={handleSelectedValueChange}
        selectedValue={selectedValue}
        options={options}
      />
    </SelectorContainer>
  )
}

SelectorComponent.propTypes = {
  handleSelectedValueChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  selectedValue: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  shouldDisplayAsterisk: PropTypes.bool.isRequired
}

export default SelectorComponent



// WEBPACK FOOTER //
// ./src/components/modal/CreateOrEditCourseModal/InputComponents/SelectorComponent.js